import { useEffect } from "react";
import { PALETTE } from "@/components/cobrain/tokens";
import { AuditOutlineForm } from "./AuditOutlineForm";

/* Lightweight wrapper so the low-commitment offer can appear anywhere on the
   page without duplicating the form. */

export function OutlineModal({ open, onClose, context }: {
  open: boolean; onClose: () => void; context?: string;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Get the audit outline by email"
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 90,
        background: "rgba(23,21,19,0.55)", backdropFilter: "blur(4px)",
        display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative", width: "100%", maxWidth: 480,
          background: PALETTE.bg, borderRadius: 22, border: `1px solid ${PALETTE.line}`,
          padding: "clamp(24px, 4vw, 34px)",
          boxShadow: "0 40px 80px -20px rgba(0,0,0,0.4)",
          maxHeight: "88vh", overflowY: "auto",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute", top: 12, right: 14, background: "transparent", border: 0,
            cursor: "pointer", color: PALETTE.muted, fontSize: 20, lineHeight: 1, padding: 4,
          }}
        >
          ×
        </button>
        <AuditOutlineForm context={context} source="services_outline_modal" />
      </div>
    </div>
  );
}

export default OutlineModal;
